import { render, staticRenderFns } from "./ContentList.vue?vue&type=template&id=fa3e8e7a&scoped=true&"
import script from "./ContentList.vue?vue&type=script&lang=js&"
export * from "./ContentList.vue?vue&type=script&lang=js&"
import style0 from "./ContentList.vue?vue&type=style&index=0&id=fa3e8e7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3e8e7a",
  null
  
)

/* custom blocks */
import block0 from "./ContentList.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports